import normal from './normal'
import mute from './mute'
import vertical from './vertical'
import horizontal from './horizontal'
import nav from './nav'
import postfooter from './postfooter'
import portfolio from './portfolio'

const links = {
  normal,
  mute,
  vertical,
  horizontal,
  nav,
  postfooter,
  portfolio
}

export default links